import NotificationsWidgetModule from './notifications-widget.module'

export default NotificationsWidgetModule
